import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import MediatorManager from "../../../core/application/MediatorManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import LaptopNavigateEvent from "../../../ngt/laptop/model/LaptopNavigateEvent";
import DashboardOpenerMediator from "../../dashboard/view/DashboardOpenerMediator";
import FeedbackEvent from "../../feedback/event/FeedbackEvent";
import InternalStakeholdersMediator from "../../internal-stakeholders/view/InternalStakeholdersMediator";
import KeyDecisionEvent from "../../key-decisions/event/KeyDecisionEvent";
import KeyDecisionInteractionEvent from "../../key-decisions/event/KeyDecisionInteractionEvent";
import MapFactory from "../../map/controller/MapFactory";
import MapModel from "../../map/model/MapModel";
import TeaCornerOpenerMediator from "../../tea-corner/view/TeaCornerOpenerMediator";
import TimerEvent from "../../timer/event/TimerEvent";
import TimerMediator from "../../timer/view/TimerMediator";
import StoryVariables from "../../util/StoryVariables";
import HubEvent from "../event/HubEvent";
import HubKeyDecisionListMediator from "./HubKeyDecisionListMediator";
import KeyDecision from "../../key-decisions/model/KeyDecision";
import KeyDecisionAnswer from "../../key-decisions/model/KeyDecisionAnswer";
import KeyDecisionDefinition from "../../key-decisions/model/KeyDecisionDefinition";
import CurrentMapChangedEvent from "../../map/event/CurrentMapChangedEvent";

export default class HubScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {MediatorManager} mediatorManager 
     * @param {MapModel} mapModel 
     * @param {MapFactory} mapFactory 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, mediatorManager, mapModel, mapFactory, keyDecisionsModel, variableManager, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._keyDecisionsModel = keyDecisionsModel;
        this._mediatorManager = mediatorManager;
        this._mapModel = mapModel;
        this._mapFactory = mapFactory;
        this._variableManager = variableManager;
        this._languagePack = languagePack;

        this._hasFocus = true;

        this._currentChapter = 1;

        this._queuedAvailableKeyDecisionEvents = [];

        this._keyDecisionsInitialized = false;
    }

    initialize() {
        super.initialize();

        this._laptopMediator = this._mediatorManager.createMediator(this._target.laptopButton, SkinKeyRegistry.LAPTOP_OPENER_MEDIATOR);
        this._smartphoneMediator = this._mediatorManager.createMediator(this._target.smartphoneButton, SkinKeyRegistry.SMARTPHONE_OPENER);
        /** @type {HubKeyDecisionListMediator} */
        this._keyDecisionListMediator = this._mediatorManager.createMediator(this._target.hubTimeline.keyDecisionsContainer, SkinKeyRegistry.HUB_KEY_DECISION_LIST_SKIN);
        /** @type {InternalStakeholdersMediator} */
        this._internalStakeholdersMediator = this._mediatorManager.createMediator(this._target.internalStakeholders, SkinKeyRegistry.INTERNAL_STAKEHOLDERS);
        /** @type {TeaCornerOpenerMediator} */
        this._teaCornerOpenerMediator = this._mediatorManager.createMediator(this._target.teaCorner, SkinKeyRegistry.TEA_CORNER_OPENER);
        /** @type {TimerMediator} */
        this._timerMediator = this._mediatorManager.createMediator(this._target.timerKeyDecision, SkinKeyRegistry.TIMER);




        this._updateMap();
        this._initializeDashboard();

        this.registerEventListener(KeyDecisionEvent.KEY_DECISION_AVAILABLE, this._handleKeyDecisionAvailable.bind(this));
        this.registerEventListener(KeyDecisionEvent.KEY_DECISION_UNAVAILABLE, this._handleKeyDecisionUnavailable.bind(this));

        this.registerEventListener(KeyDecisionInteractionEvent.CONFIRM_KEY_DECISION_SEEN, this._handleConfirmKeyDecisionSeen.bind(this));

        this.registerEventListener(LaptopNavigateEvent.LAPTOP_SHOW_REQUEST, this._handleBlur.bind(this));
        this.registerEventListener(LaptopNavigateEvent.LAPTOP_HIDE_REQUEST, this._handleFocus.bind(this));

        this.registerEventListener(TimerEvent.START_TIMER, this._handleStartTimer.bind(this));

        this.registerEventListener(HubEvent.SHOW_REQUEST, this.show.bind(this));
        this.registerEventListener(HubEvent.HIDE_REQUEST, this.hide.bind(this));

        this.registerEventListener(HubEvent.REFRESH_KEY_DECISIONS_LIST, this._showNextQueuedAvailableKeyDecision.bind(this));

        this.registerEventListener(CurrentMapChangedEvent.CURRENT_MAP_CHANGED, this._handleCurrentMapChanged.bind(this));

        this._target.TimingBG.WeekLabel.text = "";

        this.hide();


        // DEBUG
        if (ranj.DEBUG) {
            this._handleKeyUp = function (e) {
                var c = String.fromCharCode(e.which).toLowerCase();
                if (e.shiftKey && c == "f") {
                    var keyDecision = new KeyDecision();
                    keyDecision.keyDecisionDefinition = new KeyDecisionDefinition("chapter_1_1", 1, "c1_1_composeplan_keydecision1", "c1_1_emailni_idpclinicsupervisor", "key_decision_background_email_workspace"),
                        keyDecision._optimalAnswers = [
                            new KeyDecisionAnswer("Immediately notify the Ministry of Health of cases in READY clinics and request guidance.", "Prioritizes timely reporting and collaboration with the MoH, which are important components of a successful outbreak response effort.", "good"),
                            new KeyDecisionAnswer("Develop a new operational readiness plan for this emerging outbreak", "Not enough is known about the pathogen at this point to completely update the plan.", "good"),
                            new KeyDecisionAnswer("Update health staff on the situation and remind the team to follow Infection Prevention and Control. Temporarily reduce clinic services to only emergency patients to limit potential spread of the disease.", "This could harm the community and the situation is not bad enough to justify concidering this option.", "good")
                        ];
                    keyDecision._playerAnswers = [
                        new KeyDecisionAnswer("Update health staff on the situation and remind the team to follow Infection Prevention and Control protocols.", "By notifying staff about the possible outbreak and describing appropriate IPC measures, steps to prevent more cases can be taken and ensure that patients and staff are protected.", "good"),
                        new KeyDecisionAnswer("Reach out to other NGOs to triangulate information.", "Reaching out to other NGOs to gather additional information can help to verify the accuracy of the data and provide a more comprehensive understanding of the situation.", "bad"),
                        new KeyDecisionAnswer("Update health staff on the situation and remind the team to follow Infection Prevention and Control. Reach out to donors to discuss potential health program adaptations and additional funding opportunities", "It's not the right moment to do this, and it's not the HPM's job to directly contact donors.", "medium"),
                    ];

                    this._keyDecisionsModel._completedKeyDecisions = [
                        keyDecision,
                        keyDecision,
                        keyDecision
                    ]
                    this.dispatch(FeedbackEvent.OPEN_SCREEN_REQUEST);
                }
            }.bind(this);
            window.addEventListener("keyup", this._handleKeyUp);
        }
    }

    

    destroy() {
        super.destroy();

        this._laptopMediator.destroy();
        this._smartphoneMediator.destroy();
        this._keyDecisionListMediator.destroy();
        this._internalStakeholdersMediator.destroy();
        this._teaCornerOpenerMediator.destroy();
        this._timerMediator.destroy();
        this._dashboardOpenerMediator.destroy();

        this._laptopMediator = null;
        this._smartphoneMediator = null;
        this._keyDecisionListMediator = null;

        this._destroyMap();
    }

    show() {
        this._updateCurrentLabels();
        this._initializeKeyDecisions();
        createjs.Tween.get(this._target).wait(500).to({ alpha: 1 }, 750, createjs.Ease.sineOut);
    }

    hide() {
        this._target.alpha = 0;
    }

    _updateMap() {
        this._destroyMap();

        this._mapMediator = this._mapFactory.createMap(this._target.mapContainer, this._mapModel.currentMapId);
    }

    _destroyMap() {
        if (this._mapMediator) {
            this._mapMediator.destroy();
            this._mapMediator = null;

            this._target.mapContainer.removeAllChildren();
        }
    }

    _initializeDashboard() {
        /** @type {DashboardOpenerMediator} */
        this._dashboardOpenerMediator = this._mediatorManager.createMediator(this._target.dashboardButton, SkinKeyRegistry.DASHBOARD_OPENER);
    }

    _handleKeyDecisionAvailable(evt) {
        /** @type {KeyDecisionEvent} */
        const data = evt.params.data;
        const keyDecision = data.keyDecision;

        const confirmDecisionSeenEvent = new KeyDecisionInteractionEvent(KeyDecisionInteractionEvent.CONFIRM_KEY_DECISION_SEEN, keyDecision);
        this._queuedAvailableKeyDecisionEvents.push(confirmDecisionSeenEvent);
    }

    _handleKeyDecisionUnavailable(evt) {
        /** @type {KeyDecisionEvent} */
        const data = evt.params.data;
        const keyDecision = data.keyDecision;
        this._keyDecisionListMediator.makeKeyDecisionPerformed(keyDecision);
    }

    _handleConfirmKeyDecisionSeen(evt) {
        const data = evt.params.data;
        const keyDecision = data.keyDecision;
        this._keyDecisionListMediator.makeKeyDecisionAvailable(keyDecision);
        this._showNextQueuedAvailableKeyDecision();
    }

    _handleBlur() {
        this._hasFocus = false;
    }

    _handleFocus() {
        this._hasFocus = true;
        this._updateCurrentLabels();
    }

    _showNextQueuedAvailableKeyDecision(delay = 0) {
        if (this._queuedAvailableKeyDecisionEvents.length === 0) {
            return;
        }

        const nextAvailableKeyDecisionEvent = this._queuedAvailableKeyDecisionEvents.shift();
        nextAvailableKeyDecisionEvent.delay = delay;
        this._dispatcher.dispatch(nextAvailableKeyDecisionEvent.type, { data: nextAvailableKeyDecisionEvent });
    }

    _initializeKeyDecisions () {
        if(!this._keyDecisionsInitialized) {
            this._keyDecisionsInitialized = true;
            this._keyDecisionListMediator.initializeKeyDecisions(this._keyDecisionsModel.getNumberKeyDecisionByChapter(this._currentChapter));
        }
    }

    _updateCurrentLabels() {
        const currentWeekNumber = this._variableManager.getVariable(StoryVariables.WEEK_NUMBER) || 1;
        this._currentChapter = this._variableManager.getVariable(StoryVariables.CHAPTER) || 1;
        this._target.TimingBG.ChapterLabel.text = this._languagePack.getText(`hub.chapter`) + " " + this._currentChapter;
        this._target.TimingBG.WeekLabel.text = this._languagePack.getText(`hub.week`) + " " + currentWeekNumber;
    }

    _handleStartTimer() {
        this._updateCurrentLabels();
    }

    _handleCurrentMapChanged() {
        this._updateCurrentLabels();
        this._updateMap();
    }
}